export default __webpack_public_path__ + "static/media/XMLogo.b6f3a48a.png";